import classes from "./FooterAds.module.scss";
import AdUnit, { AdUnitTypeEnum } from "./AdUnit";
import { FooterEnum } from "./config/units/footer";
import { memo } from "react";

export const FooterAds = memo(() => {
  return (
    <div className={classes.footerAds}>
      <AdUnit name={FooterEnum.DesktopIndexFooterA} type={AdUnitTypeEnum.DESKTOP} />
      <AdUnit name={FooterEnum.DesktopIndexFooterB} type={AdUnitTypeEnum.DESKTOP} />
      <AdUnit name={FooterEnum.DesktopIndexFooterC} type={AdUnitTypeEnum.DESKTOP} />
      <AdUnit name={FooterEnum.MobileFooter} type={AdUnitTypeEnum.MOBILE} />
    </div>
  );
});
